import { Component, Inject, OnInit } from '@angular/core';
import { ParentCounty, PlaceType } from '../nag-standard-modal/nag-standard-modal.component';
import { NagService } from 'app/services/nag.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { UserService } from 'app/services/user.service';

export interface NagPlacenameResolutionData {
	standard: {
		name: string;
		parentId?: number;
		source?: string;
	};
	countyList: ParentCounty[];
	nctId;
}
export interface NagPlacenameResolutionOutput {
	existingRec?: ExistingStandard;
	county: ParentCounty;
	standardName: string;
	placeTypes: string[];
}
interface ExistingStandard {
	stnId;
	placeTypes?: string[];
}

@Component({
  selector: 'app-nag-placename-reso',
  templateUrl: './nag-placename-reso.component.html',
  styleUrls: ['./nag-placename-reso.component.css', '../nag-standard-modal/nag-standard-modal.component.css']
})
export class NagPlacenameResoComponent implements OnInit {

	standardName: string;

	placeTypes: PlaceType[];
	countyList: ParentCounty[] = [];
	parentCounty: ParentCounty;

	existingRec: ExistingStandard

	private nctId;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: NagPlacenameResolutionData,
		public dialogRef: MatDialogRef<NagPlacenameResoComponent>,
		private nagService: NagService,
		private userService: UserService
	) { }
	cancel() {
		this.dialogRef.close();
	}
	apply() {
		const data: NagPlacenameResolutionOutput = {
			existingRec: this.existingRec,
			county: this.parentCounty,
			standardName: this.standardName,
			placeTypes: this.placeTypes.filter(i => i.selected).map(i => i.name)
		};
		this.dialogRef.close(data);
	}

	async onChangeCounty() {
		const standardRecords = await this.nagService.getNagNamesStandardId(this.standardName, this.nctId, this.userService.customerInfo.givState, this.parentCounty.name);
		this.existingRec = standardRecords[0];
		const existingPlaceTypes = this.existingRec.placeTypes || [];
		this.placeTypes.forEach(i => i.selected = existingPlaceTypes.indexOf(i.name) > -1);
	}

	async ngOnInit() {
		const placeTypes = this.nagService.placeTypes || await this.nagService.getNagSubCategory();
		this.placeTypes = placeTypes.map(pt => {
			return {
				name: pt.name,
				selected: false
			};
		});
		this.countyList = this.data.countyList;
		this.standardName = this.data.standard.name;
		this.nctId = this.data.nctId;
	}

}
